import _ from 'lodash'
import {
  FETCH_PROMOTION,
  FETCH_PROMOTIONS,
  CREATE_PROMOTION,
  DELETE_PROMOTION,
  CREATE_PROMOTION_CODES
} from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PROMOTIONS:
      return action.payload
    case FETCH_PROMOTION:
      return { ...state, [action.payload.id]: action.payload }
    case CREATE_PROMOTION:
      return { ...state, [action.payload.id]: action.payload }
    case CREATE_PROMOTION_CODES:
      return { ...state, [action.payload.id]: action.payload }
    case DELETE_PROMOTION:
      return _.omit(state, action.payload)
    default:
      return state
  }
}
